"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UX_GROWL_DELAY_MS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _consensus = require("./consensus");
var _legacy = require("./legacy");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _dialog = _interopRequireWildcard(require("@ux/dialog"));
var _button = _interopRequireDefault(require("@ux/button"));
var _identifier = _interopRequireDefault(require("@ux/data-version/identifier"));
var _version = require("./version.js");
const _excluded = ["dismiss", "lifetime"],
  _excluded2 = ["type"];
/* eslint-disable no-process-env, no-console */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
let preloadedMessages = [];
const UX_GROWL_CLASSNAME = 'ux-growl';
const version = (0, _identifier.default)(false, _version.version);
const UX_GROWL_DELAY_MS = exports.UX_GROWL_DELAY_MS = '--uxGrowl-message--delayMilliseconds';

/**
 * Toggles the animation for the messages.
 *
 * @param {Object} config Configuration object.
 * @param {Element} config.currentTarget The DOM node to check.
 * @param {Number} config.lifetime How long the message should persist for.
 * @returns {Boolean} Whether or not the animation is active.
 * @private
 */
function toggleAnimationTrigger(_ref) {
  let {
    currentTarget,
    lifetime
  } = _ref;
  const exists = hasDismissal({
    currentTarget,
    lifetime
  });
  lifetime && !isNaN(lifetime) && currentTarget.style.setProperty(UX_GROWL_DELAY_MS, `${lifetime}ms`);
  return exists;
}

/**
 * Determines if the dismissal animation should exist.
 *
 * @param {Object} config Configuration object.
 * @param {Element} config.currentTarget The DOM node to check.
 * @param {Number} config.lifetime How long the message should persist for.
 * @returns {Boolean} Whether or not the dismissal animation is applied.
 * @private
 */
function hasDismissal(_ref2) {
  let {
    currentTarget,
    lifetime
  } = _ref2;
  return !isNaN(lifetime) && Boolean(currentTarget.style.getPropertyValue(UX_GROWL_DELAY_MS));
}

/**
 * Controls when the dismissal should pause.
 *
 * @param {Object} config Configuration object.
 * @param {Element} config.currentTarget The DOM node to check.
 * @param {Number} config.lifetime How long the message should persist for.
 * @param {Boolean} config.active Whether or not to pause the dismissal.
 * @private
 */
function pauseDismissal(_ref3) {
  let {
    currentTarget,
    lifetime,
    pause
  } = _ref3;
  // If the message persists, do nothing
  if (!hasDismissal({
    currentTarget,
    lifetime
  })) return;

  // Otherwise, we stop the dismissal animation from running while active
  if (pause) {
    currentTarget.style.setProperty('animation-name', 'none');
  } else {
    currentTarget.style.removeProperty('animation-name');
  }
}

/**
 * A wrapper for the <Dialog/> component which adds animation.
 *
 * @param {Object} props Component properties.
 * @param {Function} props.dismiss Function which dismisses the message by id.
 * @param {Number} props.lifetime How long the message should persist for.
 * @param {String} props.emphasis Describes the importance of the message.
 * @returns {Component} <Message/> component with a <Dialog/>.
 * @public
 */
const Message = /*#__PURE__*/(0, _react.memo)(_ref4 => {
  let {
      dismiss,
      lifetime
    } = _ref4,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  const {
    id
  } = rest;

  /**
   * Handles the animation end event, and dismisses the message if necessary.
   *
   * @param {Event} event DOM event.
   * @param {Element} event.currentTarget The DOM node to check.
   * @private
   */
  function onAnimationEnd(_ref5) {
    let {
      currentTarget
    } = _ref5;
    if (toggleAnimationTrigger({
      currentTarget,
      lifetime
    })) {
      dismiss(id);
    }
  }

  /**
   * The user has interacted with the message, pause the dismissal.
   *
   * @param {Event} event DOM event.
   * @param {Element} event.currentTarget The DOM node to check.
   * @private
   */
  function userEventIn(_ref6) {
    let {
      currentTarget
    } = _ref6;
    pauseDismissal({
      currentTarget,
      lifetime,
      pause: true
    });
  }

  /**
   * The user has stopped interacting with the message, resume the dismissal.
   *
   * @param {Event} event DOM event.
   * @param {Element} event.currentTarget The DOM node to check.
   * @private
   */
  function userEventOut(_ref7) {
    let {
      currentTarget
    } = _ref7;
    pauseDismissal({
      currentTarget,
      lifetime,
      pause: false
    });
  }
  return /*#__PURE__*/_react.default.createElement("li", {
    className: `${UX_GROWL_CLASSNAME}-message`,
    onFocus: userEventIn,
    onBlur: userEventOut,
    onMouseEnter: userEventIn,
    onMouseLeave: userEventOut,
    onAnimationEnd: onAnimationEnd
  }, /*#__PURE__*/_react.default.createElement(_dialog.default, (0, _extends2.default)({
    role: "alert",
    stretch: true,
    onClose: () => dismiss(id),
    space: {
      inline: _dialog.spaceOptions.LG,
      block: _dialog.spaceOptions.LG
    }
  }, rest)));
});
Message.propTypes = {
  /** Function which dismisses the message by id */
  dismiss: _propTypes.default.func,
  /** How long the message should persist for */
  lifetime: _propTypes.default.number
};

/**
 * Create a <Growl/> component.
 *
 * @param {Object} props Configuration object.
 * @param {String} [props.closeLabel] Label for the button to clear messages.
 * @returns {Component} <Growl/> component.
 * @public
 */
function Growl() {
  let {
    closeLabel
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [messages, setMessages] = (0, _react.useState)([]);

  /**
   * Remove a message from the list of messages.
   *
   * @type {Function}
   * @param {String} id The id of the message to remove.
   * @private
   */
  const removeMessage = (0, _react.useCallback)(function remove(id) {
    setMessages(prevMessages => prevMessages.filter(message => message.id !== id));
  }, []);
  (0, _react.useEffect)(function listenConsensus() {
    const unmount = (0, _consensus.listen)({
      version
    }, function onmessage(err, _ref8) {
      let {
          type
        } = _ref8,
        config = (0, _objectWithoutProperties2.default)(_ref8, _excluded2);
      if (err) return;
      if (type === 'addGrowlMessage') {
        setMessages(prevMessages => prevMessages.concat((0, _legacy.transform)(config)));
      } else if (type === 'removeGrowlMessage') {
        removeMessage(config.id);
      }
    });

    /**
     * Add a Growl message to the the page.
     *
     * @param {Object} config The configuration object for the message.
     * @public
     */
    Growl.addGrowlMessage = function addGrowlMessage(config) {
      (0, _consensus.dispatch)({
        action: 'message',
        version
      }, _objectSpread({
        type: 'addGrowlMessage'
      }, config));
    };

    /**
     * Remove a Growl message from the page.
     *
     * @param {String} id The id of the message to remove.
     * @public
     */
    Growl.removeGrowlMessage = function removeGrowlMessage(id) {
      (0, _consensus.dispatch)({
        action: 'message',
        version
      }, {
        type: 'removeGrowlMessage',
        id
      });
    };
    while (preloadedMessages.length > 0) {
      Growl.addGrowlMessage(preloadedMessages.shift());
    }
    return unmount;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // The above disabled exhaustive-deps becuase addMessage and removeMessage are stable due to useCallback

  const clearButton = /*#__PURE__*/_react.default.createElement(_button.default, {
    className: `${UX_GROWL_CLASSNAME}-clear`,
    text: closeLabel || 'Close All',
    onClick: () => setMessages([]),
    design: "primary"
  });
  const growl = /*#__PURE__*/_react.default.createElement("div", {
    "data-version": '2400',
    className: `${UX_GROWL_CLASSNAME}-shell`,
    "aria-live": "polite"
  }, messages.length > 1 && clearButton, /*#__PURE__*/_react.default.createElement("ul", {
    className: `${UX_GROWL_CLASSNAME}-messages`
  }, messages.map(props => /*#__PURE__*/_react.default.createElement(Message
  // eslint-disable-next-line react/prop-types
  , (0, _extends2.default)({
    key: props.id
    // Always use the internal remove message instead of Growl.removeGrowlMessage in case of a double mount.
    ,
    dismiss: removeMessage
  }, props)))));
  return messages.length ? /*#__PURE__*/_reactDom.default.createPortal(growl, document.body) : null;
}

/**
 * Add a Growl message to the the page.
 *
 * @param {Object} config The configuration object for the message.
 * @public
 */
Growl.addGrowlMessage = function addGrowlMessage(config) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line max-len
    console.warn('You attemped to add a growl message before <Growl /> was mounted and ready. We will attempt to replay this message when <Growl /> is finally mounted.', config);
  }
  preloadedMessages.push(config);
};

/**
 * Remove a Growl message from the page.
 *
 * @param {String} id The id of the message to remove.
 * @public
 */
Growl.removeGrowlMessage = function removeGrowlMessage(id) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line max-len
    console.warn('You attemped to remove a growl message before <Growl /> was mounted and ready. We will attempt to remove this message from the replay.', id);
  }
  preloadedMessages = preloadedMessages.filter(message => message.id !== id);
};
Growl.propTypes = {
  /** Label for the button to clear messages */
  closeLabel: _propTypes.default.string
};
var _default = exports.default = Growl;